import React, { lazy, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
// cookie
import { useCookies } from 'react-cookie';
// Importing Redux
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
// Importing Axios
import { GET_REST_MENU } from '../../axios/appiendPoints';
import { axiosInstanceNext } from '../../axios/axios';
import '../../functions/menuGrouping';
import { emptyCart, HOME } from '../../paths/defaultImage';
import { DELIVERY_TYPE, PICKUP_TYPE, SCHEDULED } from '../../webStorage/keys/sessionKeys';
import { getOrderType, getOrderTypeSession, getTableId } from '../../webStorage/manageOrderType';
import Button from '../common/buttons/Button';
import DropDownButton from '../common/buttons/DropDownButton';
import NoItemFound from '../common/noItemFound';
import { getMallCart } from '../FoodCourt/AddToCart/addToCartHttp';
import OpenSearchPage from '../popUp/openSearchPage';
import Category from './category';
import Filter from './filter';
import { compareMenuWithAppliedFilter } from './Functions/filterGrouping';
import { UPDATE_FILTERS } from '../../redux/menuFilter/types';
import { menuFilterAction } from '../../redux/menuFilter/action';
import SuspenseWrapper from '../common/suspenseWrapper';
import Skeleton from '../common/loaders/skeleton';
import Recommendations from '../../recommendations';
import { setMenuItems } from '../../webStorage/sessionStorage';
import { rcsTrack } from '../../functions/rcsTrack';
import { FILTER_ENUM } from './menuEnums'
const FilterDetails = lazy(() => import(/* webpackChunkName:"FilterDetails"*/ './filterDetails'));

function MenuItems(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const [filterPopup, setFilterPopup] = useState(false);
  const sessionSetting = getOrderTypeSession();
  const orderTypeFromRedux = sessionSetting?.orderType;
  const orderTimeFromRedux = useSelector((state) => state.orderTypeOrderTime.orderType);
  const timeFromRedux = useSelector((state) => state.orderTypeOrderTime.orderTime);
  const epochFromRedux = useSelector((state) => state.orderTypeOrderTime.epoch);
  const { repeatItems, bestSellerItems, recsLoaded } = useSelector(
    (state) => state.recommendations
  );
  const orderType = orderTypeFromRedux;
  const filteredItems = useSelector((store) => store.menuFilterReducer);
  const [vegCheck, setVegCheck] = useState(false);
  const [showPopups, setShowPopups] = useState(false);
  const [openSeachPopUp, setOpenSeachPopUp] = useState(false);
  let [menu, setMenu] = useState([]);
  const [cookies, setCookie] = useCookies();
  const [menuResponse, setMenuResponse] = useState(null);
  const [hideCounterPrintBtn, setHideCounterPrintBtn] = useState(false);
  const counterPrintBtnRef = useRef(null);
  let [errorMessage, setErrorMessage] = useState('');

  const dispatch = useDispatch();
  const { mall } = useParams();
  const FCAction = useMemo(
    () =>
      mall && lazy(() => import(/* webpackChunkName:"FCAction"*/ '../../redux/FoodCourt/action')),
    []
  );

  const [filterData, setFilterData] = useState(null);
  const [collapse, setCollapse] = useState(0);
  const [showOutOfStockEnabled, setShowOutOfStockEnabled] = useState(false);
  const restarantSettingFromRedux = useSelector((state) => state.restSetting?.Setting);
  useEffect(() => {
    restarantSettingFromRedux?.settings?.menu?.collapse &&
      setCollapse(restarantSettingFromRedux?.settings?.menu?.collapse);
      setShowOutOfStockEnabled(restarantSettingFromRedux?.settings?.global?.show_out_of_stock_enabled);
  }, [restarantSettingFromRedux]);
  //to fetch menu

  const goBackHandler = () => {
    dispatch(menuFilterAction([], UPDATE_FILTERS));
    history.push(HOME);
  };

  const getMenu = (_) => {
    if (!props.restId || !getOrderType(true)) return;
    let params = new URLSearchParams();
    params.append('restaurant_id', props.restId);
    params.append('order_type', getOrderType(true));
    if (
      sessionSetting?.orderTime == 'SCHEDULED' &&
      (orderTypeFromRedux == DELIVERY_TYPE || orderTypeFromRedux == PICKUP_TYPE) &&
      sessionSetting?.epoch > parseInt(Date.now() / 1000)
    ) {
      params.append('epoch', sessionSetting?.epoch);
      // console.log('time scheduled');
    }
    axiosInstanceNext
      .post(GET_REST_MENU, params)
      .then((response) => {
        setMenuResponse(
          response.data?.data?.items?.filter((item) => {
            return item?.is_ee === 1;
          })
        );
      })
      .catch((err) => {
        console.error(err.message);
        setErrorMessage(err.message);
      });
  };

  const hideCategoryDropDown = () => {
    if (openSeachPopUp && counterPrintBtnRef?.current?.getBoundingClientRect()?.y === 0) {
      setHideCounterPrintBtn(true);
    } else {
      setHideCounterPrintBtn(false);
    }
  };

  useEffect(() => {
    //apply filters on menu items when user changes filter data
    if (!menuResponse) return;
    const filteredMenuItems = compareMenuWithAppliedFilter(
      menuResponse,
      filteredItems,
      orderType,
      vegCheck
    );
    setFilterData(filteredMenuItems);
    const showOutOfStockItems = showOutOfStockEnabled && (Array.isArray(filteredItems) && filteredItems.length===0 ? true : filteredItems.some(obj => obj.id === FILTER_ENUM.AVAILABLE && obj.selected===false));
    const { group } = filteredMenuItems.EasyEatGroupMenu(showOutOfStockItems);

    // Recommendations
    const menuItems = filteredMenuItems.EasyEatMenuItems(showOutOfStockItems);
    setMenuItems(menuItems);

    setMenu(group);
  }, [menuResponse, filteredItems, vegCheck,restarantSettingFromRedux]);

  useEffect(() => {
    if (menuResponse) {
      rcsTrack('categoryPage', { resId: props.restId });
    }
  }, [menuResponse]);

  useEffect(() => {
    if (bestSellerItems?.length) {
      const bestSellerFormat = {
        id: 'recommended',
        name: 'Recommended',
        items: [{ name: 'Bestseller', items: bestSellerItems, id: 'bestseller' }],
        cat_length: bestSellerItems.length,
      };
      if (menu[0]?.id !== 'recommended') {
        setMenu((prev) => [bestSellerFormat, ...prev]);
      }
      if (menu[0]?.id === 'recommended') {
        const filteredMenu = menu;
        filteredMenu[0] = bestSellerFormat;
        setMenu(filteredMenu);
      }
    }
  }, [bestSellerItems, props.restId, filterData]);

  useEffect(getMenu, [
    orderTimeFromRedux,
    timeFromRedux,
    epochFromRedux,
    props.restId,
    getOrderType(true),
  ]);

  const close = () => {
    setOpenSeachPopUp(0);
  };
  useEffect(
    () =>
      mall &&
      getMallCart({
        mall,
        dispatch,
        FCAction,
        token: cookies.fcCartToken,
        table_id: getTableId(),
      }),
    []
  );
  const showPopup = (value) => {
    setShowPopups(value);
  };

  useEffect(() => {
    if (orderTimeFromRedux?.orderTime == SCHEDULED)
      setCookie('epoch', orderTimeFromRedux?.epoch, { path: '/' });
  }, [orderTimeFromRedux?.orderTime]);

  useEffect(() => {
    hideCategoryDropDown();
    window.removeEventListener('scoll', () => {});
    window.addEventListener('scroll', () => {
      hideCategoryDropDown();
    });
  }, [openSeachPopUp]);
  if (menuResponse) {
    if (!menuResponse.length) {
      return (
        <NoItemFound img={emptyCart} header={t('sorry_no')} subHeader={t('menu_items_update')}>
          <Button
            text={t('explore_other_restaurants')}
            type='primary w-90 fs-14'
            onClick={goBackHandler}
          />
        </NoItemFound>
      );
    } else {
      return (
        <>
          {recsLoaded && (
            <div
              ref={counterPrintBtnRef}
              className={`horizontalScrollMenuContainer gap-4 d-flex justify-content-between mb-2
            ${hideCounterPrintBtn ? 'hide-visibility' : ''}
            ${showPopups ? 'z-index-10' : 'z-index-1'}
            `}
              style={{ top: mall ? '0rem' : '3.9rem' }}>
              {(Array.isArray(menu) && menu.length && (
                <DropDownButton
                  customClass='counter-print-dropdown flex-3'
                  list={menu}
                  showPopupVal={showPopup}
                />
              )) || <div className='d-none'></div>}
              <Filter
                menu={filterData}
                vegCheck={vegCheck}
                setVegCheck={setVegCheck}
                setFilterPopup={setFilterPopup}
                setOpenSeachPopUp={setOpenSeachPopUp}
              />
            </div>
          )}
          {!!repeatItems.length && (
            <Recommendations
              title='Repeat your previous items'
              recs={repeatItems}
              from='menu'
              recsType='repeat_items'
            />
          )}
          {filterData?.length === 0 && (
            <NoItemFound img={emptyCart} header={t('sorry_no')} subHeader={t('menu_items_update')}>
              <Button
                text={t('explore_other_restaurants')}
                type='primary w-90 fs-14'
                onClick={goBackHandler}
              />
            </NoItemFound>
          )}
          {recsLoaded && filterData?.length !== 0 && <Category menu={menu} collapse={collapse} />}
          {!recsLoaded && <Skeleton block='menuCard' count={3} />}
          {openSeachPopUp ? <OpenSearchPage close={close} menu={filterData} /> : null}
          {filterPopup && (
            <SuspenseWrapper>
              <FilterDetails close={() => setFilterPopup(false)} />
            </SuspenseWrapper>
          )}
        </>
      );
    }
  } else if (errorMessage) {
    return (
      <>
        <div className='text-center loaderStyle' style={{ height: '100vh' }}>
          <p className='pr-2'>😟</p>
          <p className='text-capitalize'>{t('something_went_wrong')}</p>
        </div>
      </>
    );
  } else {
    return <Skeleton block='menuCard' count={3} />;
  }
}
export default MenuItems;
